var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7372 0.51709H3.33823C1.58423 0.51709 0.308594 1.79273 0.308594 3.54673V38.9457C0.308594 40.5402 1.74368 41.9753 3.33823 41.9753H38.7372C40.4912 41.9753 41.7668 40.6996 41.7668 38.9457V3.54673C41.7668 1.79273 40.3317 0.51709 38.7372 0.51709ZM13.065 35.5971H6.68678V16.4626H13.065V35.5971ZM9.87587 13.9113C7.80296 13.9113 6.04896 12.1573 6.04896 10.0844C6.04896 8.01146 7.80296 6.25746 9.87587 6.25746C11.9488 6.25746 13.7028 8.01146 13.7028 10.0844C13.7028 12.1573 11.9488 13.9113 9.87587 13.9113ZM35.3886 35.5971H29.0104V26.0298C29.0104 23.4786 28.3726 20.9273 25.8213 20.9273C23.2701 20.9273 22.6322 23.4786 22.6322 26.0298V35.5971H16.2541V16.4626H22.6322V18.6949H22.9512C23.7484 17.1004 25.8213 15.8247 28.2132 15.8247C34.113 15.8247 35.3886 19.6516 35.3886 24.4353V35.5971Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.edeeca143655cbcbdf3526113d8c7ebb.svg";
export { ForwardRef as ReactComponent };